import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialogActions, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { IconComponent } from '@libs/components/icons';
import { SUPPORT_EMAIL, SUPPORT_PHONE_HREF, SUPPORT_PHONE_LABEL } from '@libs/shared/common';
import { NavItemModel } from '@libs/shared/models';
import { ButtonLinkComponent } from '../../actions/button-link';

@Component({
  selector: 'ui-no-permission-dialog',
  templateUrl: './no-permission-dialog.component.html',
  styleUrls: ['./no-permission-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ButtonLinkComponent,
    IconComponent,
    MatDialogActions,
    MatDialogContent,
    MatDialogTitle,
  ],
})
export class NoPermissionDialogComponent {
  protected readonly supportEmail: string = SUPPORT_EMAIL;
  protected readonly supportPhoneLabel: string = SUPPORT_PHONE_LABEL;
  protected readonly supportPhoneHref: string = SUPPORT_PHONE_HREF;

  protected readonly title: string = 'Zugriff noch nicht möglich';
  protected readonly subtitle: string = 'Für Ihr Konto wurde bisher keine Berechtigung für das neue Portal gefunden.';
  // eslint-disable-next-line max-len
  protected readonly messageBeforePhone: string = 'Um Zugriff auf das neue Portal zu erhalten brauchen wir zunächst weitere Informationen von Ihnen. Bitte wenden Sie sich an unseren Lekkerland Helpdesk - telefonisch unter';
  protected readonly messageBeforeEmail: string = 'oder per E-Mail an';
  protected readonly messageAfterEmail: string = '- mit den Informationen, mit welcher E-Mailadresse und Kundennummer Sie Zugriff für das neue LMIV-Portal angefragt haben.';
  protected readonly supportTitle: string = 'Sie haben Fragen?';
  protected readonly supportText: string = 'Unser Helpdesk unterstützt Sie gerne weiter.';
  protected readonly helpdeskLabel: string = 'Zum Helpdesk';

  protected readonly helpdeskLink: NavItemModel = { url: `mailto:${SUPPORT_EMAIL}` };
}
